


















import {bus} from "@/main"
import {Component, Prop, Vue} from "vue-property-decorator"
import {AppraisalItem, getAppraisalTitlePath} from "@/data/repos/appraisal"
import DataGrid, {DataType} from "@/components/DataGrid.vue"
import {executeQuery} from "@/data/repos/query"
import ModalContainer from "@/components/dialogs/ModalContainer.vue"
import AppraisalResidualRiskDrillDown2 from "@/components/widgets/appraisal/AppraisalResidualRiskDrillDown2.vue"

const link = Vue.component('el-link', {
  functional: true,
  render: function(createElement, ctx) {
    return createElement('div', {
        style: {
          cursor: "pointer",
          color: "blue",
        },
        on: {click: () => ctx.props.callback(ctx.props.parameters.fName, ctx.props.parameters.row)},
      },
      String(ctx.props.parameters.row[ctx.props.parameters.fName] || ""))
  },
  props: {
    parameters: Object,
    callback: Function,
  },
})

@Component({
  components: {
    ModalContainer,
    DataGrid,
    AppraisalResidualRiskDrillDown2,
  },
})
export default class AppraisalResidualRiskDrillDown extends Vue {
  @Prop() public args!: { locationId: number, risk: AppraisalItem }
  private data: any[] | null = null
  private riskFieldPrefix = "countOfRisk"
  private dataGridFields: any[] | null = null
  public drillDown2Show = false
  public drillDown2Args: { locationId: number, row: any, riskId: number, riskLabel: string, aprItems: AppraisalItem } | null = null

  public get title() {
    return "Appraisal residual risk breakdown - " + getAppraisalTitlePath(this.args.risk)
  }

  public drillDown2Hide() {
    this.drillDown2Show = false
    this.drillDown2Args = null
  }

  public getFields(countOfRiskFields: Map<String, Number>) {
    const riskFields: any = []
    for (const field of [...countOfRiskFields.entries()].sort((a: any, b: any) => b[1] - a[1])) {
      riskFields.push({
        name: field[0],
        title: field[0].substr(this.riskFieldPrefix.length),
        dataType: DataType.Number,
        sort: 1,
        component: link,
        callback: (fName: string, row: any) => {
          const riskId = row[fName + "_id"]
          const riskLabel = fName.substr(this.riskFieldPrefix.length)
          this.drillDown2Args = {locationId: row.buildingId, row, riskId, riskLabel, aprItems: this.args.risk}
          this.drillDown2Show = true
        },
      })
    }
    const fields = [
      {name: 'regionName', title: 'Region', dataType: DataType.Text, sort: 1},
      {name: 'siteName', title: 'Site', dataType: DataType.Text, sort: 1},
      {name: 'buildingName', title: 'Building', dataType: DataType.Text, sort: 1},
      ...riskFields,
    ]
    this.dataGridFields = fields
    return fields
  }

  public async getData(offset = 0) {
    if (offset) {
      return []
    }
    if (!this.data) {
      const resp = await this.loadData(this.args.locationId, this.args.risk)
      if (resp) {
        this.getFields(resp[1])
        this.data = resp[0]
      }
    }
    return this.data
  }

  private async loadData(locationId: number, risk: any): Promise<any[] | null> {
    // console.log("load data", JSON.stringify(risk, null, 1))
    const queryName = risk.subelementId ? "appraisal.residual_risk.residualRiskDrillDown_subelement" :
      risk.elementId ? "appraisal.residual_risk.residualRiskDrillDown_element" :
        risk.categoryId ? "appraisal.residual_risk.residualRiskDrillDown_category" :
          risk.facetId ? "appraisal.residual_risk.residualRiskDrillDown_facet" :
            risk.surveyId ? "appraisal.residual_risk.residualRiskDrillDown_survey" : null
    const args: any = risk.subelementId ? {subelementId: risk.subelementId} :
      risk.elementId ? {elementId: risk.elementId} :
        risk.categoryId ? {categoryId: risk.categoryId} :
          risk.facetId ? {facetId: risk.facetId} :
            risk.surveyId ? {surveyId: risk.surveyId} : null
    args.locationId = locationId
    if (queryName) {
      return executeQuery("idr", queryName, args, this.filter)
    }
    return []
  }

  private filter(data: any[]): [any, Map<String, Number>] {
    const riskMap: Map<Number, RiskItem> = new Map<Number, RiskItem>()
    const buildingIdSet: Set<number> = new Set()
    const countOfRiskFields = new Map<String, Number>()
    for (const item of data) {
      const buildingId = item.buildingid
      buildingIdSet.add(buildingId)
      const existingRisk = riskMap.get(buildingId)
      countOfRiskFields.set(this.riskFieldPrefix + item.riskLabel, item.riskUpperValue)
      if (existingRisk) {
        existingRisk.riskCountMap.set(item.riskLabel, [item.CountOfRisk, item.riskID])
      } else {
        let riskCountMap: Map<string, number[]> = new Map([[item.riskLabel, [item.CountOfRisk, item.riskID]]])
        riskMap.set(buildingId, {
          regionName: item.regionname,
          siteName: item.sitename,
          buildingName: item.buildingname,
          buildingCode: item.buildingcode,
          buildingId: item.buildingid,
          riskCountMap,
          riskLabel: item.riskLabel,
        } as RiskItem)
      }
    }
    const riskItems: RiskItem[] = []
    for (const buildingId of buildingIdSet.values()) {
      const item = riskMap.get(buildingId)
      if (item) {
        let record: any = {...item}
        for (const risk of item.riskCountMap.entries()) {
          record[this.riskFieldPrefix + risk[0]] = risk[1][0]
          record[this.riskFieldPrefix + risk[0] + "_id"] = risk[1][1]
        }
        delete record.riskCountMap
        riskItems.push(record)
      }
    }
    return [riskItems, countOfRiskFields]
  }

  public close() {
    bus.$emit("modalBoxDestroy")
  }

  public download() {
    const fileDownload = require('js-file-download')
    fileDownload(JSON.stringify(this.data), "appraisal-residual-risk.json")
  }
}

interface RiskItem {
  regionName: string,
  siteName: string,
  buildingName: string,
  buildingCode: string,
  buildingId: string,
  riskLabel: string,
  riskIDs: Map<string, number>,
  riskCountMap: Map<string, number[]>,
}

